
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './Launch.scss'
import Button from '../../partials/Button'


import HiddenPanel from "../../partials/HiddenPanel"
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";

import LaunchSites from '../../partials/LaunchSites'

const LaunchLocation = (props) => {
    const { data } = props
    const { locations, subjects } = getDataProps(data || {});

    const missionRequirements = (data.missionRequirements !== undefined)
        ? (
            <HiddenPanel button="Mission Requirements">
                <div ></div>
                {data.missionRequirements}
            </HiddenPanel>
        )
        : null;

    return (
        <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
            <div className="back-btn-container">
                <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
            </div>
            <div className="launch_container">
                <div className="Results">
                    <LaunchSites rocketrep={subjects} locations={locations} onChoosedLocation={() => {
                        if (props.onComplete) {
                            props.onComplete()
                        }
                    }} />
                </div>
            </div>
            {missionRequirements}
        </InteractionContainer>
    )
}
function getDataProps(data) {
    const { locations, subjects } = data || {}
    if (!locations) throw new Error('Invalid or missing prop data: locations')
    if (!subjects) throw new Error('Invalid or missing prop data: subjects')

    return { locations, subjects }
}


export default LaunchLocation

LaunchLocation.propTypes = {
    data: PropTypes.object.isRequired,
    globals: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired
}
